import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

const lightGray: string = constants.colors.ui.neutral[100];

export const modalFooterCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  height: "81px",
  padding: "16px",
  borderTop: "1px solid" + lightGray,
  justifyContent: "end",
};

export const footerButtonsWrapper: CSSObject = {
  display: "flex",
};

export const cancelButtonCss: CSSObject = {
  marginRight: "10px",
};
